import { copy, padwithlast } from "@js/utils";
import { scenarios, usedremaining, autopercent } from "@js/scenario";
import picker from "@js/picker";

/**
 * Given historical emissions and other params calculate a sequence of
 * emission trajectories
 * @param {Array} emissionsdatasum historical emissions 
 * @param {{ first_year: Number, last_year: Number }} time_axis first and last year for the period
 * @param {Object} budget budget object
 * @param {Number} currentyear 
 * @returns {Array<Array>}
 */
export function emissionsequence(
  emissionsdatasum,
  time_axis,
  budget,
  currentyear
) {

  let emissionseq = [];
  for (let year = 2001; year <= currentyear; year += 1) {
    let [lastemission, , remaining_tons] = usedremaining(
      emissionsdatasum[0],
      time_axis,
      year,
      budget
    );

    let p = autopercent(lastemission, remaining_tons);
    p = Math.round(p * 10) / 10; //round to one decimal.

    //console.log("scenariostartyear: ", year, " autopercent: ", p);
    //the required yearly percent has gone from -4.7 at 2001
    //to -16.8 at 2020. maybe interesting data to show.
    emissionseq.push(
      scenarios(emissionsdatasum, budget, year, time_axis, [p])[0]
    );
  }
  return emissionseq;
}

/**
 * Get sectoremissions as vector of vectors [[1,2,3],[1,2,3]]
 * in order specified by sectornames also expand length of vectors
 * the returned "copy" emissionsdata can be modified by scenarios etc and passed to plot
 * @param {Object} data 
 * @param {Array<string>} sectornames 
 * @returns 
 */
export function emissionslist(data, sectornames) {
  let emissions_sectors = [];
  for (let i = 0; i < sectornames.length; i++) {
    let [emissions_sector] = picker.picksector(data, sectornames[i]);
    emissions_sector = padwithlast(copy(emissions_sector), 26); // TODO: 26 shouldn't be hardcoded, right?
    emissions_sectors.push(emissions_sector);
  }
  return emissions_sectors;
}
